import "normalize.css";
import "../../scss/style.scss";
import "../script.js";
import "@fortawesome/fontawesome-free/js/all.js";

document.addEventListener("DOMContentLoaded", function () {
  const main = document.querySelector(".main");
  const button = document.querySelector(".central__button");
  button.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      main.classList.add("none");
      // setTimeout(() => {
      //   main.remove();
      // }, 400);
    },
    false
  );

  const desc = document.querySelector(".painting__desc");

  document.querySelector(".link").addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      desc.classList.toggle("links");
    },
    false
  );

  document.querySelector(".font").addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      desc.classList.toggle("bold");
    },
    false
  );

  const defaultFontSize = parseInt(
    window.getComputedStyle(desc, null).getPropertyValue("font-size"),
    10
  );

  const changeFontSize = (val) => {
    let t = parseInt(window.getComputedStyle(desc).fontSize, 10);
    desc.style.fontSize = t + val + "px";
    desc.style.lineHeight = t + val + "px";
  };

  document
    .querySelector(".in")
    .addEventListener("click", () => changeFontSize(8), false);
  document
    .querySelector(".out")
    .addEventListener("click", () => changeFontSize(-8), false);

  document.querySelector(".reset").addEventListener(
    "click",
    () => {
      desc.style.fontSize = defaultFontSize + "px";
      desc.style.lineHeight = defaultFontSize + "px";
      desc.classList.remove("bold");
      desc.classList.remove("decoration");
    },
    false
  );
});
